<template>
  <head>
    <meta charset="utf-8" />
    <title>Pending Clearance Certificates</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <div id="layout-wrapper">
    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Page Header -->
          <div class="row mb-4">
            <div class="col-12">
              <div class="page-header-card">
                <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                  <div class="d-flex align-items-center">
                    <div class="page-icon bg-warning-subtle me-3">
                      <i class="mdi mdi-clock-alert text-warning"></i>
                    </div>
                    <div>
                      <h4 class="mb-1 fw-bold">Pending Clearance Certificates</h4>
                      <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0">
                          <li class="breadcrumb-item"><a href="javascript: void(0);" class="text-muted">Land & Plots</a></li>
                          <li class="breadcrumb-item"><a href="javascript: void(0);" class="text-muted">Clearance Certificates</a></li>
                          <li class="breadcrumb-item active text-warning">Pending</li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                  <router-link :to="{name: 'clearance-dashboard'}" class="btn btn-outline-secondary">
                    <i class="mdi mdi-arrow-left me-1"></i> Back to Dashboard
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- Toolbar -->
          <ToolBarClearance/>

          <!-- Stats Cards -->
          <div class="row g-3 mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-warning-subtle rounded-circle me-3">
                      <i class="mdi mdi-clock-outline text-warning"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Pending</p>
                      <h4 class="mb-0 fw-bold text-warning">{{ summary.count || 0 }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-success-subtle rounded-circle me-3">
                      <i class="mdi mdi-cash-multiple text-success"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Pending Value</p>
                      <h4 class="mb-0 fw-bold text-success">KES {{ numberFormat(totalPendingValue) }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-info-subtle rounded-circle me-3">
                      <i class="mdi mdi-calendar-today text-info"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Today's Pending</p>
                      <h4 class="mb-0 fw-bold text-info">{{ todaysPending }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stat-card border-0 shadow-sm h-100">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <div class="mini-stat-icon bg-primary-subtle rounded-circle me-3">
                      <i class="mdi mdi-timer-sand text-primary"></i>
                    </div>
                    <div>
                      <p class="text-muted mb-1 small text-uppercase fw-semibold">Avg. Wait Time</p>
                      <h4 class="mb-0 fw-bold text-primary">{{ avgWaitTime }}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Card -->
          <div class="row">
            <div class="col-12">
              <div class="card border-0 shadow-sm">
                <!-- Card Header -->
                <div class="card-header bg-white py-3">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div class="d-flex align-items-center">
                      <div class="icon-box bg-warning text-white rounded me-3">
                        <i class="mdi mdi-clock-outline"></i>
                      </div>
                      <div>
                        <h5 class="mb-0 fw-bold">Pending Approval</h5>
                        <small class="text-muted">Search property and approve certificates</small>
                      </div>
                    </div>
                    <div class="d-flex flex-wrap gap-2">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="keyword" type="text" class="form-control" placeholder="Search..." style="min-width: 200px;">
                          <i class="mdi mdi-magnify search-icon"></i>
                        </div>
                      </div>
                      <button @click="getClearanceCertificates" class="btn btn-outline-primary" :disabled="loading">
                        <i class="mdi mdi-refresh" :class="{'mdi-spin': loading}"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Table -->
                <div class="card-body p-0">
                  <div class="table-responsive">
                    <table class="table table-hover align-middle mb-0">
                      <thead class="bg-light">
                      <tr>
                        <th class="border-0 ps-4">Bill Details</th>
                        <th class="border-0">Property/Description</th>
                        <th class="border-0">Applicant</th>
                        <th class="border-0">Location</th>
                        <th class="border-0 text-end">Amount</th>
                        <th class="border-0">Date</th>
                        <th class="border-0 text-center pe-4">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in certificates" :key="index" class="certificate-row">
                        <td class="ps-4">
                          <div class="d-flex align-items-center">
                            <div class="bill-icon bg-primary-subtle text-primary rounded me-3">
                              <i class="mdi mdi-file-document-outline"></i>
                            </div>
                            <div>
                              <h6 class="mb-0 fw-semibold">{{ item.billNo }}</h6>
                              <span class="badge bg-light text-dark small">{{ item.feeDescription }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.customer || item.description || '-' }}</div>
                          <small class="text-muted">{{ item.category }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.names }}</div>
                          <small class="text-muted"><i class="mdi mdi-card-account-details-outline me-1"></i>{{ item.idNo }}</small>
                        </td>
                        <td>
                          <div class="fw-medium">{{ item.subCountyName }}</div>
                          <small class="text-muted">{{ item.wardName }}</small>
                        </td>
                        <td class="text-end">
                          <div class="fw-bold text-success">KES {{ numberFormat(item.billTotal) }}</div>
                        </td>
                        <td>
                          <div class="small">{{ formatDate(item.dateCreated) }}</div>
                          <span class="badge bg-warning-subtle text-warning small">{{ getWaitTime(item.dateCreated) }}</span>
                        </td>
                        <td class="text-center pe-4">
                          <div class="btn-group">
                            <button v-if="getRight('CLEARANCE APPROVE')" @click="selectForApproval(item)" class="btn btn-sm btn-soft-success" data-bs-toggle="modal" data-bs-target="#approveModal" title="Approve">
                              <i class="mdi mdi-check-bold"></i>
                            </button>
                            <button v-if="getRight('CLEARANCE DECLINE')" @click="selectForDecline(item)" class="btn btn-sm btn-soft-danger" data-bs-toggle="modal" data-bs-target="#declineModal" title="Decline">
                              <i class="mdi mdi-close-thick"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>

                    <!-- Loading -->
                    <div class="text-center py-5" v-if="loading">
                      <div class="spinner-border text-warning mb-3"></div>
                      <h6 class="text-muted">Loading...</h6>
                    </div>

                    <!-- Empty -->
                    <div class="text-center py-5" v-if="certificates.length === 0 && !loading">
                      <div class="empty-icon mb-3"><i class="mdi mdi-check-circle text-success"></i></div>
                      <h5 class="text-success fw-bold">All Caught Up!</h5>
                      <p class="text-muted">No pending certificates to review.</p>
                    </div>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white py-3" v-if="certificates.length > 0">
                  <div class="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <select v-model="pageSize" class="form-select form-select-sm" style="width: 80px;">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                    </select>
                    <nav>
                      <ul class="pagination pagination-sm mb-0">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <a class="page-link" @click="prevPage"><i class="mdi mdi-chevron-left"></i></a>
                        </li>
                        <li class="page-item" v-for="page in visiblePages" :key="page" :class="{ active: currentPage === page }">
                          <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <a class="page-link" @click="nextPage"><i class="mdi mdi-chevron-right"></i></a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ENHANCED Approve Modal with Property Search -->
      <div class="modal fade" id="approveModal" tabindex="-1" data-bs-backdrop="static">
        <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content border-0">
            <div class="modal-header bg-success text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-check-circle me-2"></i>Approve Certificate - Select Property</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">

              <!-- Step Indicator -->
              <div class="step-indicator mb-4">
                <div class="d-flex justify-content-center">
                  <div class="step" :class="{ 'active': approvalStep === 1, 'completed': approvalStep > 1 }">
                    <div class="step-circle">1</div>
                    <div class="step-label">Search Property</div>
                  </div>
                  <div class="step-line"></div>
                  <div class="step" :class="{ 'active': approvalStep === 2 }">
                    <div class="step-circle">2</div>
                    <div class="step-label">Confirm & Approve</div>
                  </div>
                </div>
              </div>

              <!-- Certificate Summary -->
              <div class="summary-box p-3 rounded bg-light mb-4">
                <div class="row">
                  <div class="col-md-4">
                    <span class="text-muted small">Bill No</span>
                    <div class="fw-bold">{{ selectedCertificate.billNo }}</div>
                  </div>
                  <div class="col-md-4">
                    <span class="text-muted small">Applicant</span>
                    <div class="fw-bold">{{ selectedCertificate.names }}</div>
                  </div>
                  <div class="col-md-4">
                    <span class="text-muted small">Amount Paid</span>
                    <div class="fw-bold text-success">KES {{ numberFormat(selectedCertificate.billTotal) }}</div>
                  </div>
                </div>
              </div>

              <!-- Step 1: Property Search -->
              <div v-if="approvalStep === 1">
                <div class="card border-primary mb-3">
                  <div class="card-header bg-primary text-white">
                    <h6 class="mb-0 text-white"><i class="mdi mdi-magnify me-2"></i>Step 1: Search and Select Property</h6>
                  </div>
                  <div class="card-body">
                    <div class="row mb-3">
                      <div class="col-12">
                        <label class="form-label fw-semibold">Search Property (LR Number, UPN, Owner Name)</label>
                        <div class="input-group">
                          <span class="input-group-text bg-white">
                            <i class="mdi mdi-magnify text-muted"></i>
                          </span>
                          <input
                              v-model="propertySearchKeyword"
                              type="text"
                              class="form-control form-control-lg"
                              placeholder="Start typing to search...">
                          <span v-if="searchingProperties" class="input-group-text bg-white">
                            <span class="spinner-border spinner-border-sm text-primary"></span>
                          </span>
                        </div>
                        <small class="text-muted">Type at least 2 characters to search</small>
                      </div>
                    </div>

                    <!-- Search Results -->
                    <div v-if="propertySearchResults.length > 0" class="property-results">
                      <h6 class="text-muted mb-2">{{ propertySearchResults.length }} Properties Found - Click to Select</h6>
                      <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
                        <table class="table table-hover table-sm mb-0">
                          <thead class="table-light sticky-top">
                          <tr>
                            <th>Select</th>
                            <th>UPN / LR No</th>
                            <th>Owner</th>
                            <th>Location</th>
                            <th>Balance</th>
                            <th>Status</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="prop in propertySearchResults" :key="prop.id"
                              :class="{ 'table-success': selectedProperty && selectedProperty.id === prop.id }"
                              @click="selectProperty(prop)" style="cursor: pointer;">
                            <td>
                              <input type="radio" :checked="selectedProperty && selectedProperty.id === prop.id" name="propertySelect">
                            </td>
                            <td>
                              <div class="fw-bold text-primary">{{ prop.UPN || prop.LRNumber }}</div>
                              <small class="text-muted">{{ prop.LRNumber }}</small>
                            </td>
                            <td>
                              <div>{{ prop.ownerNames }}</div>
                              <small class="text-muted">{{ prop.ownerPhoneNo }}</small>
                            </td>
                            <td>
                              <div>{{ prop.subCountyName }}</div>
                              <small class="text-muted">{{ prop.zone }}</small>
                            </td>
                            <td>
                                <span :class="parseFloat(prop.currentBalance) > 0 ? 'text-danger fw-bold' : 'text-success fw-bold'">
                                  KES {{ numberFormat(prop.currentBalance) }}
                                </span>
                            </td>
                            <td>
                              <span class="badge" :class="prop.status === 'Active' ? 'bg-success' : 'bg-warning'">{{ prop.status }}</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <!-- No Results -->
                    <div v-if="propertySearchResults.length === 0 && propertySearchKeyword.length >= 2 && !searchingProperties" class="text-center py-4">
                      <i class="mdi mdi-magnify-close text-muted" style="font-size: 48px;"></i>
                      <p class="text-muted mt-2">No properties found matching "{{ propertySearchKeyword }}"</p>
                    </div>

                    <!-- Initial State -->
                    <div v-if="propertySearchKeyword.length < 2 && propertySearchResults.length === 0" class="text-center py-4">
                      <i class="mdi mdi-home-search text-muted" style="font-size: 48px;"></i>
                      <p class="text-muted mt-2">Start typing to search for a property</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Step 2: Confirm Property Details & Approve -->
              <div v-if="approvalStep === 2 && selectedProperty">
                <div class="card border-success mb-3">
                  <div class="card-header bg-success text-white">
                    <h6 class="mb-0 text-white"><i class="mdi mdi-home-check me-2"></i>Step 2: Confirm Property & Approve</h6>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="property-detail-card p-3 bg-light rounded mb-3">
                          <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-home me-2"></i>Property Information</h6>
                          <table class="table table-sm table-borderless mb-0">
                            <tr><td class="text-muted" width="40%">UPN:</td><td class="fw-bold">{{ selectedProperty.UPN }}</td></tr>
                            <tr><td class="text-muted">LR Number:</td><td class="fw-bold">{{ selectedProperty.LRNumber }}</td></tr>
                            <tr><td class="text-muted">Zone:</td><td class="fw-bold">{{ selectedProperty.zone || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Block:</td><td class="fw-bold">{{ selectedProperty.block || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Land Use:</td><td class="fw-bold">{{ selectedProperty.useName || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Size:</td><td class="fw-bold">{{ selectedProperty.percelSize ? selectedProperty.percelSize + ' Ha' : 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Address:</td><td class="fw-bold">{{ selectedProperty.percelAddress || 'N/A' }}</td></tr>
                          </table>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="property-detail-card p-3 bg-light rounded mb-3">
                          <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-account me-2"></i>Owner Information</h6>
                          <table class="table table-sm table-borderless mb-0">
                            <tr><td class="text-muted" width="40%">Owner:</td><td class="fw-bold">{{ selectedProperty.ownerNames }}</td></tr>
                            <tr><td class="text-muted">ID No:</td><td class="fw-bold">{{ selectedProperty.ownerID || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Phone:</td><td class="fw-bold">{{ selectedProperty.ownerPhoneNo || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Email:</td><td class="fw-bold">{{ selectedProperty.ownerEmail || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Sub-County:</td><td class="fw-bold">{{ selectedProperty.subCountyName }}</td></tr>
                            <tr><td class="text-muted">Ward:</td><td class="fw-bold">{{ selectedProperty.wardName || 'N/A' }}</td></tr>
                            <tr><td class="text-muted">Status:</td><td><span class="badge" :class="selectedProperty.status === 'Active' ? 'bg-success' : 'bg-warning'">{{ selectedProperty.status }}</span></td></tr>
                          </table>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="property-detail-card p-3 bg-light rounded">
                          <h6 class="text-primary fw-bold mb-3"><i class="mdi mdi-cash me-2"></i>Financial Summary</h6>
                          <div class="row text-center">
                            <div class="col-md-3">
                              <div class="p-2 bg-white rounded">
                                <small class="text-muted d-block">Annual Land Rates</small>
                                <strong class="text-success">KES {{ numberFormat(selectedProperty.annualLandRates) }}</strong>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="p-2 bg-white rounded">
                                <small class="text-muted d-block">Annual Ground Rent</small>
                                <strong class="text-info">KES {{ numberFormat(selectedProperty.annualGroundRent) }}</strong>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="p-2 bg-white rounded">
                                <small class="text-muted d-block">Total Payments</small>
                                <strong class="text-primary">KES {{ numberFormat(selectedProperty.payments) }}</strong>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="p-2 bg-white rounded">
                                <small class="text-muted d-block">Current Balance</small>
                                <strong :class="parseFloat(selectedProperty.currentBalance) > 0 ? 'text-danger' : 'text-success'">
                                  KES {{ numberFormat(selectedProperty.currentBalance) }}
                                </strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- BALANCE NOT CLEARED WARNING & VERIFICATION -->
                    <div v-if="hasOutstandingBalance" class="balance-warning-section mt-4">
                      <div class="alert alert-danger border-danger">
                        <div class="d-flex align-items-start">
                          <i class="mdi mdi-alert-octagon text-danger me-3" style="font-size: 48px;"></i>
                          <div class="flex-grow-1">
                            <h5 class="alert-heading text-danger fw-bold mb-2">
                              <i class="mdi mdi-exclamation-thick me-1"></i>Outstanding Balance Detected!
                            </h5>
                            <p class="mb-2">
                              This property has an <strong>UNPAID BALANCE</strong> of
                              <span class="badge bg-danger fs-6">KES {{ numberFormat(selectedProperty.currentBalance) }}</span>
                            </p>
                            <p class="mb-0 small">
                              Approving a clearance certificate for a property with outstanding balance is <strong>NOT RECOMMENDED</strong>.
                              This action will be logged and may be subject to audit review.
                            </p>
                          </div>
                        </div>
                      </div>

                      <!-- Verification Steps -->
                      <div class="verification-box p-4 border border-danger rounded bg-light">
                        <h6 class="fw-bold text-danger mb-3">
                          <i class="mdi mdi-shield-alert me-2"></i>Required Verification Steps
                        </h6>

                        <!-- Step 1: Acknowledge -->
                        <div class="form-check mb-3">
                          <input class="form-check-input" type="checkbox" v-model="acknowledgedBalance" id="acknowledgeBalance">
                          <label class="form-check-label" for="acknowledgeBalance">
                            I acknowledge that this property has an outstanding balance of <strong class="text-danger">KES {{ numberFormat(selectedProperty.currentBalance) }}</strong>
                          </label>
                        </div>

                        <!-- Step 2: Accept Terms -->
                        <div class="form-check mb-3">
                          <input class="form-check-input" type="checkbox" v-model="acceptedTerms" id="acceptTerms" :disabled="!acknowledgedBalance">
                          <label class="form-check-label" for="acceptTerms">
                            I accept full responsibility for approving this clearance certificate and understand this action will be logged for audit purposes
                          </label>
                        </div>

                        <!-- Step 3: Type Confirmation -->
                        <div class="mb-3" :class="{ 'opacity-50': !acceptedTerms }">
                          <label class="form-label fw-semibold">
                            Type <span class="text-danger fw-bold">"BALANCE CLEARED"</span> to confirm approval:
                          </label>
                          <input
                              type="text"
                              class="form-control form-control-lg text-center text-uppercase"
                              v-model="balanceConfirmationText"
                              :disabled="!acceptedTerms"
                              placeholder="Type here..."
                              :class="{
                              'border-success': balanceConfirmationText.toUpperCase() === 'BALANCE CLEARED',
                              'border-danger': balanceConfirmationText && balanceConfirmationText.toUpperCase() !== 'BALANCE CLEARED'
                            }">
                          <div v-if="balanceConfirmationText && balanceConfirmationText.toUpperCase() !== 'BALANCE CLEARED'" class="text-danger small mt-1">
                            <i class="mdi mdi-close-circle me-1"></i>Text does not match. Please type exactly: BALANCE CLEARED
                          </div>
                          <div v-if="balanceConfirmationText.toUpperCase() === 'BALANCE CLEARED'" class="text-success small mt-1">
                            <i class="mdi mdi-check-circle me-1"></i>Confirmation accepted
                          </div>
                        </div>

                        <!-- Verification Status -->
                        <div class="verification-status p-3 rounded" :class="canApproveWithBalance ? 'bg-success-subtle' : 'bg-warning-subtle'">
                          <div class="d-flex align-items-center">
                            <i class="mdi me-2" :class="canApproveWithBalance ? 'mdi-check-circle text-success' : 'mdi-clock-outline text-warning'" style="font-size: 24px;"></i>
                            <div>
                              <strong v-if="canApproveWithBalance" class="text-success">All verification steps completed</strong>
                              <strong v-else class="text-warning">Complete all verification steps to proceed</strong>
                              <div class="small text-muted">
                                Step 1: {{ acknowledgedBalance ? '✓' : '○' }} |
                                Step 2: {{ acceptedTerms ? '✓' : '○' }} |
                                Step 3: {{ balanceConfirmationText.toUpperCase() === 'BALANCE CLEARED' ? '✓' : '○' }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Balance Cleared Message -->
                    <div v-else class="alert alert-success mt-3">
                      <i class="mdi mdi-check-circle me-2"></i>
                      <strong>Balance Cleared!</strong> This property has no outstanding balance. You can proceed with approval.
                    </div>

                    <div class="mt-3">
                      <label class="form-label fw-semibold">Approval Notes <span v-if="hasOutstandingBalance" class="text-danger">*</span></label>
                      <textarea v-model="approvalNotes" class="form-control" rows="2" :placeholder="hasOutstandingBalance ? 'Provide justification for approving with outstanding balance...' : 'Add any notes about this approval (optional)...'"></textarea>
                      <small v-if="hasOutstandingBalance" class="text-muted">Notes are required when approving with outstanding balance</small>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>

              <!-- Step Navigation -->
              <button v-if="approvalStep > 1" @click="approvalStep--" type="button" class="btn btn-secondary">
                <i class="mdi mdi-arrow-left me-1"></i> Back
              </button>

              <button v-if="approvalStep === 1" @click="approvalStep = 2" type="button" class="btn btn-primary" :disabled="!selectedProperty">
                Next: Confirm & Approve <i class="mdi mdi-arrow-right ms-1"></i>
              </button>

              <button v-if="approvalStep === 2" @click="approveCertificate" class="btn btn-success" :disabled="processing || !canApprove">
                <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Processing...</span>
                <span v-else><i class="mdi mdi-check-bold me-1"></i>Approve Certificate</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Decline Modal -->
      <div class="modal fade" id="declineModal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content border-0">
            <div class="modal-header bg-danger text-white">
              <h5 class="modal-title text-white"><i class="mdi mdi-close-circle me-2"></i>Decline Certificate</h5>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedCertificate">
              <div class="text-center mb-4">
                <div class="decline-icon mb-3"><i class="mdi mdi-close-circle text-danger"></i></div>
                <h6 class="fw-bold">Confirm Decline</h6>
              </div>
              <div class="summary-box p-3 rounded bg-light mb-3">
                <div class="d-flex justify-content-between mb-2">
                  <span class="text-muted">Bill No</span>
                  <strong>{{ selectedCertificate.billNo }}</strong>
                </div>
                <div class="d-flex justify-content-between">
                  <span class="text-muted">Applicant</span>
                  <strong>{{ selectedCertificate.names }}</strong>
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label fw-semibold">Reason for Declining <span class="text-danger">*</span></label>
                <textarea v-model="declineReason" class="form-control" rows="3" placeholder="Enter reason..." required></textarea>
              </div>
            </div>
            <div class="modal-footer border-0">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button @click="declineCertificate" class="btn btn-danger" :disabled="processing || !declineReason.trim()">
                <span v-if="processing"><span class="spinner-border spinner-border-sm me-1"></span>Processing...</span>
                <span v-else><i class="mdi mdi-close me-1"></i>Decline</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer"><div class="container-fluid"><div class="row"><div class="col-sm-6"></div></div></div></footer>
    </div>
  </div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToolBarClearance from "@/components/landrate/ToolBarClearance.vue";
import moment from "moment/moment";
import { execute, getRight, landRate } from "@/api";

export default {
  name: "PendingClearanceCertificates",
  components: { NavigationBar, ToolBarClearance },
  data() {
    return {
      loading: false,
      processing: false,
      keyword: '',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      certificates: [],
      selectedCertificate: null,
      approvalNotes: '',
      declineReason: '',
      summary: { count: 0 },

      // Property Search
      approvalStep: 1,
      propertySearchKeyword: '',
      propertySearchResults: [],
      searchingProperties: false,
      selectedProperty: null,
      searchDebounceTimer: null,

      // Balance verification
      balanceConfirmationText: '',
      acceptedTerms: false,
      acknowledgedBalance: false
    }
  },
  computed: {
    totalPendingValue() {
      return this.certificates.reduce((sum, cert) => sum + parseFloat(cert.billTotal || 0), 0);
    },
    todaysPending() {
      const today = moment().format('YYYY-MM-DD');
      return this.certificates.filter(cert => moment(cert.dateCreated).format('YYYY-MM-DD') === today).length;
    },
    avgWaitTime() {
      if (this.certificates.length === 0) return '0 days';
      const totalDays = this.certificates.reduce((sum, cert) => sum + moment().diff(moment(cert.dateCreated), 'days'), 0);
      const avg = Math.round(totalDays / this.certificates.length);
      return avg === 1 ? '1 day' : `${avg} days`;
    },
    visiblePages() {
      const pages = [];
      let start = Math.max(1, this.currentPage - 2);
      let end = Math.min(this.totalPages, start + 4);
      if (end - start < 4) start = Math.max(1, end - 4);
      for (let i = start; i <= end; i++) pages.push(i);
      return pages;
    },
    hasOutstandingBalance() {
      return this.selectedProperty && parseFloat(this.selectedProperty.currentBalance || 0) > 0;
    },
    canApproveWithBalance() {
      if (!this.hasOutstandingBalance) return true;
      return this.acknowledgedBalance &&
          this.acceptedTerms &&
          this.balanceConfirmationText.toUpperCase() === 'BALANCE CLEARED';
    },
    canApprove() {
      if (!this.selectedProperty) return false;
      if (this.hasOutstandingBalance) {
        return this.canApproveWithBalance && this.approvalNotes.trim().length > 0;
      }
      return true;
    }
  },
  watch: {
    pageSize() { this.currentPage = 1; this.getClearanceCertificates(); },
    keyword() { this.currentPage = 1; this.getClearanceCertificates(); },
    propertySearchKeyword(newVal) {
      // Clear previous timer
      if (this.searchDebounceTimer) {
        clearTimeout(this.searchDebounceTimer);
      }

      // Clear results if search is empty
      if (!newVal || newVal.trim().length < 2) {
        this.propertySearchResults = [];
        return;
      }

      // Debounce search - wait 400ms after user stops typing
      this.searchDebounceTimer = setTimeout(() => {
        this.searchProperties();
      }, 400);
    }
  },
  mounted() {
    this.getClearanceCertificates();
  },
  methods: {
    getRight(type) { return getRight(type); },
    numberFormat(num) { return new Intl.NumberFormat("en-GB").format(num || 0); },
    formatDate(date) { return date ? moment(date).format('DD MMM YYYY HH:mm') : ''; },
    getWaitTime(date) {
      if (!date) return '';
      const days = moment().diff(moment(date), 'days');
      if (days === 0) return 'Today';
      return days === 1 ? '1 day ago' : `${days} days ago`;
    },
    prevPage() { if (this.currentPage > 1) { this.currentPage--; this.getClearanceCertificates(); } },
    nextPage() { if (this.currentPage < this.totalPages) { this.currentPage++; this.getClearanceCertificates(); } },
    goToPage(page) { if (page !== this.currentPage) { this.currentPage = page; this.getClearanceCertificates(); } },

    getClearanceCertificates() {
      this.loading = true;
      this.certificates = [];

      const data = new FormData();
      data.append("function", "getClearanceCertificates");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", this.keyword);
      data.append("approvalStatus", "PENDING");

      execute(data, landRate)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.certificates = res.data.data.certificates || [];
              this.summary.count = res.data.data.count?.count || 0;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }
          })
          .catch((e) => { this.loading = false; console.error(e); });
    },

    selectForApproval(item) {
      this.selectedCertificate = item;
      this.approvalNotes = '';
      this.approvalStep = 1;
      this.propertySearchKeyword = '';
      this.propertySearchResults = [];
      this.selectedProperty = null;
      // Reset balance verification
      this.balanceConfirmationText = '';
      this.acceptedTerms = false;
      this.acknowledgedBalance = false;
    },

    selectForDecline(item) {
      this.selectedCertificate = item;
      this.declineReason = '';
    },

    /**
     * Search properties from the property table
     */
    searchProperties() {
      const searchTerm = this.propertySearchKeyword.trim();

      if (searchTerm.length < 2) {
        this.propertySearchResults = [];
        return;
      }

      this.searchingProperties = true;

      const data = new FormData();
      data.append("function", "getLandRates");
      data.append("search", searchTerm);
      data.append("page", 1);
      data.append("rows_per_page", 50);

      execute(data, landRate)
          .then((res) => {
            this.searchingProperties = false;
            if (res.data.success) {
              this.propertySearchResults = res.data.data.properties || [];
            }
          })
          .catch((e) => {
            this.searchingProperties = false;
            console.error('Search error:', e);
          });
    },

    /**
     * Select a property from search results
     */
    selectProperty(property) {
      this.selectedProperty = property;
    },

    /**
     * Approve certificate with selected property details
     */
    approveCertificate() {
      if (!this.selectedCertificate || !this.selectedProperty) {
        alert('Please select a property before approving');
        return;
      }

      // Validate balance override requirements
      if (this.hasOutstandingBalance) {
        if (!this.canApproveWithBalance) {
          alert('Please complete all verification steps before approving');
          return;
        }
        if (!this.approvalNotes.trim()) {
          alert('Please provide justification notes for approving with outstanding balance');
          return;
        }
      }

      this.processing = true;

      const data = new FormData();
      data.append("function", "approveClearanceCertificate");
      data.append("id", this.selectedCertificate.id);
      data.append("billNo", this.selectedCertificate.billNo);
      data.append("notes", this.approvalNotes);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      // Balance override flag
      data.append("balanceOverride", this.hasOutstandingBalance ? '1' : '0');
      data.append("outstandingBalance", this.selectedProperty.currentBalance || 0);

      // Property details
      data.append("propertyID", this.selectedProperty.id);
      data.append("UPN", this.selectedProperty.UPN || '');
      data.append("LRNumber", this.selectedProperty.LRNumber || '');
      data.append("plotNo", this.selectedProperty.plotNo || '');
      data.append("ownerNames", this.selectedProperty.ownerNames || '');
      data.append("ownerID", this.selectedProperty.ownerID || '');
      data.append("ownerPhoneNo", this.selectedProperty.ownerPhoneNo || '');
      data.append("ownerEmail", this.selectedProperty.ownerEmail || '');
      data.append("percelAddress", this.selectedProperty.percelAddress || '');
      data.append("percelSize", this.selectedProperty.percelSize || '');
      data.append("block", this.selectedProperty.block || '');
      data.append("useName", this.selectedProperty.useName || '');
      data.append("annualLandRates", this.selectedProperty.annualLandRates || 0);
      data.append("annualGroundRent", this.selectedProperty.annualGroundRent || 0);
      data.append("landRatesArrears", this.selectedProperty.landRatesArrears || 0);
      data.append("groundRentArrears", this.selectedProperty.groundRentArrears || 0);
      data.append("accumPenalty", this.selectedProperty.accumPenalty || 0);
      data.append("accumInterest", this.selectedProperty.accumInterest || 0);
      data.append("payments", this.selectedProperty.payments || 0);
      data.append("currentBalance", this.selectedProperty.currentBalance || 0);
      data.append("propertyStatus", this.selectedProperty.status || 'Active');
      data.append("propertySubCountyID", this.selectedProperty.subCountyID || '');
      data.append("propertySubCountyName", this.selectedProperty.subCountyName || '');
      data.append("propertyWardID", this.selectedProperty.wardID || '');
      data.append("propertyWardName", this.selectedProperty.wardName || '');
      data.append("propertyZone", this.selectedProperty.zone || '');

      execute(data, landRate)
          .then((res) => {
            this.processing = false;
            if (res.data.success) {
              alert("Certificate approved successfully!");
              this.closeModal('approveModal');
              this.getClearanceCertificates();
            } else {
              alert("Error: " + res.data.message);
            }
          })
          .catch((e) => {
            this.processing = false;
            alert("Error: " + e.message);
          });
    },

    declineCertificate() {
      if (!this.selectedCertificate || !this.declineReason.trim()) return alert("Please provide a reason.");
      this.processing = true;

      const data = new FormData();
      data.append("function", "declineClearanceCertificate");
      data.append("id", this.selectedCertificate.id);
      data.append("billNo", this.selectedCertificate.billNo);
      data.append("declineReason", this.declineReason);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, landRate)
          .then((res) => {
            this.processing = false;
            if (res.data.success) { alert("Certificate declined!"); this.closeModal('declineModal'); this.getClearanceCertificates(); }
            else alert("Error: " + res.data.message);
          })
          .catch((e) => { this.processing = false; alert("Error: " + e.message); });
    },

    closeModal(modalId) {
      const modal = document.getElementById(modalId);
      if (modal) { const instance = bootstrap.Modal.getInstance(modal); if (instance) instance.hide(); }
    }
  }
}
</script>

<style scoped>
.page-header-card { background: linear-gradient(135deg, #fff9e6 0%, #fff 100%); padding: 1.25rem; border-radius: 12px; border: 1px solid #f1b44c33; }
.page-icon { width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; border-radius: 12px; font-size: 28px; }
.mini-stat-card { border-radius: 12px; transition: all 0.3s ease; }
.mini-stat-card:hover { transform: translateY(-3px); box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important; }
.mini-stat-icon { width: 48px; height: 48px; display: flex; align-items: center; justify-content: center; font-size: 24px; }
.icon-box { width: 44px; height: 44px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
.bill-icon { width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-size: 18px; }
.search-box { position: relative; }
.search-box .search-icon { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #adb5bd; }
.certificate-row:hover { background-color: rgba(241, 180, 76, 0.05); }
.btn-soft-success { color: #34c38f; background-color: rgba(52, 195, 143, 0.1); border: none; }
.btn-soft-success:hover { color: #fff; background-color: #34c38f; }
.btn-soft-danger { color: #f46a6a; background-color: rgba(244, 106, 106, 0.1); border: none; }
.btn-soft-danger:hover { color: #fff; background-color: #f46a6a; }
.bg-warning-subtle { background-color: rgba(241, 180, 76, 0.15) !important; }
.bg-success-subtle { background-color: rgba(52, 195, 143, 0.15) !important; }
.bg-info-subtle { background-color: rgba(80, 165, 241, 0.15) !important; }
.bg-primary-subtle { background-color: rgba(85, 110, 230, 0.15) !important; }
.empty-icon { width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; margin: 0 auto; background: rgba(52, 195, 143, 0.1); border-radius: 50%; }
.empty-icon i { font-size: 50px; }
.decline-icon { width: 80px; height: 80px; display: flex; align-items: center; justify-content: center; margin: 0 auto; border-radius: 50%; background: rgba(244, 106, 106, 0.1); }
.decline-icon i { font-size: 48px; }
.summary-box { border: 1px solid #e9ecef; }
.page-link { cursor: pointer; border-radius: 6px !important; margin: 0 2px; }
.page-item.active .page-link { background-color: #556ee6; border-color: #556ee6; }

/* Step Indicator Styles */
.step-indicator { padding: 20px 0; }
.step { display: flex; flex-direction: column; align-items: center; position: relative; }
.step-circle { width: 40px; height: 40px; border-radius: 50%; background: #e9ecef; display: flex; align-items: center; justify-content: center; font-weight: bold; color: #6c757d; transition: all 0.3s; }
.step.active .step-circle { background: #556ee6; color: white; }
.step.completed .step-circle { background: #34c38f; color: white; }
.step-label { margin-top: 8px; font-size: 12px; font-weight: 500; color: #6c757d; }
.step.active .step-label { color: #556ee6; font-weight: 600; }
.step.completed .step-label { color: #34c38f; }
.step-line { width: 80px; height: 2px; background: #e9ecef; margin: 20px 10px 0 10px; }

/* Property Results Styles */
.property-results { border: 1px solid #e9ecef; border-radius: 8px; padding: 15px; background: #f8f9fa; }
.property-detail-card { border: 1px solid #e9ecef; }

/* Balance Verification Styles */
.balance-warning-section { }
.verification-box { background: #fff5f5; }
.verification-box .form-check-input:checked { background-color: #dc3545; border-color: #dc3545; }
.verification-status { transition: all 0.3s ease; }
.bg-success-subtle { background-color: rgba(52, 195, 143, 0.15) !important; }
.bg-warning-subtle { background-color: rgba(241, 180, 76, 0.15) !important; }
</style>